/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
// import { useToast } from "@/hooks/use-toast";
import { zodResolver } from "@hookform/resolvers/zod";
import { useEffect } from "react";
import { useForm } from "react-hook-form";

import { z } from "zod";

type UseUserformType = {
  formData: any;
  onFormSubmit: (prop: any) => Promise<any>;
  open: boolean;
  onOpenChange: (prop: boolean) => void;
};

const formSchema = z.object({
  // is_new: z.boolean(),
  uom: z.string().min(1, {
    message: "UOM is required.",
  }),
  erp_uom: z.string().min(1, {
    message: "Erp Uom is required.",
  }),
  retailer_id: z
    .array(z.string().min(1))
    .min(1, { message: "At least one retailer is required." }),
  sku_code: z.any().optional(),
  conversion_rate: z.number().optional(),
  po_uom_qty: z.number().optional(),
  decimal_places: z.any().optional(),
});

export const useReactForm = ({
  formData,
  onFormSubmit,
  onOpenChange,
}: // open,
UseUserformType) => {
  // const { toast } = useToast();
  const schemaKeys = formSchema.keyof().options;

  const form = useForm<z.infer<typeof formSchema>>({
    resolver: zodResolver(formSchema),
    mode: "onBlur",
    defaultValues: {
      retailer_id: [],
      uom: "",
      erp_uom: "",
      sku_code: [],
      conversion_rate: 1,
      po_uom_qty: 1,
      decimal_places: null,
    },
  });

  useEffect(() => {
    if (formData && Object.keys(formData).length > 0) {
      schemaKeys.forEach((key) => {
        if (key === "sku_code" && !Array.isArray(formData[key])) {
          const value = formData[key];
          console.log({ value });
          form.setValue(key, [value], {
            shouldTouch: true,
            shouldDirty: true,
          });
        } /* else if (key === "retailer_id" && !Array.isArray(formData[key])) {
          const value = formData[key];
          console.log({ value });
          form.setValue(key, value ? [value] : [], {
            shouldTouch: true,
            shouldDirty: true,
          });
        } */ else {
          const value = formData[key];
          form.setValue(key, value, {
            shouldTouch: true,
            shouldDirty: true,
          });
        }
      });
      if (formData["retailers"]) {
        const tempValue = formData["retailers"].map(
          (item: any) => item.retailer_id,
        );
        form.setValue("retailer_id", tempValue, {
          shouldTouch: true,
          shouldDirty: true,
        });
      }
    }
  }, [formData]);

  async function onSubmit(values: z.infer<typeof formSchema>) {
    const { data } = await onFormSubmit(values);
    if (data) {
      // toast({
      //   title: "Success",
      //   variant: "success",
      //   description: data.status.msg,
      // });
      onOpenChange(false);
    }
  }

  return { form, onSubmit };
};
